import {useIntl} from 'react-intl';

export type MessagesDictionary = {
  requiredField: string
  notValidEmail: string
  serverError: string
  successCreatedInvoiceOrder: string
  totalAmountErrorMessage: string
  inviteSuccess: string
  inviteError: string
  userDetailsSuccess: string
  textPasswordMismatch: string
  generalAuthError: string
  userDoesntExistError: string
  userAlreadyExistsError: string
  incorrectPasswordError: string
  checkLinkInEmail: string
  passwordChangeSuccess: string
  currentPasswordMismatch: string
  newPasswordMismatch: string
  newPasswordMustBeDifferentFromOld: string
  multipleUsersFound: string
  incorrectOTC: string
  notValidPhoneNumber: string
  fillPersonalDetails: string
  userEmailAlreadyExistsError: string
  userPhoneAlreadyExistsError: string
  customerNameIsAgentNameError: string
  customerIdIsAgentIdError: string
  invalidIdNumberError: string
};

export const useMessage = () => {
  const {formatMessage} = useIntl();
  const requiredField = formatMessage({
    id: 'message-error-requiredField',
    defaultMessage: 'Required field'
  });
  const notValidEmail = formatMessage({
    id: 'input-email-error-not-valid-email',
    defaultMessage: 'Is not valid email',
  });
  const serverError = formatMessage({
    id: 'message-error-serverError',
    defaultMessage: 'A general error occurred, please try again or contact support'
  });
  const successCreatedInvoiceOrder = formatMessage({
    id: 'message-invoice-order-was-successful',
    defaultMessage: 'The invoice order was successful, additional orders can be made.'
  });
  const totalAmountErrorMessage = formatMessage({
    id: 'orderInvoice-total-amount-error-message',
    defaultMessage: "Total can't be 0",
  });
  const inviteSuccess = formatMessage({
    id: 'inviteFriend-page-submit-success',
    defaultMessage: "The invitation has been sent",
  });
  const inviteError = formatMessage({
    id: 'inviteFriend-page-submit-error',
    defaultMessage: "Error",
  });
  const userDetailsSuccess = formatMessage({
    id: 'settings-submit-user-details-success',
    defaultMessage: "User details changed successfully.",
  });
  const passwordChangeSuccess = formatMessage({
    id: 'settings-submit-new-password-success',
    defaultMessage: "Password changed successfully.",
  });
  const currentPasswordMismatch = formatMessage({
    id: 'settings-current-password-mismatch',
    defaultMessage: "Current password mismatch.",
  });
  const newPasswordMismatch = formatMessage({
    id: 'settings-new-password-mismatch',
    defaultMessage: "New password mismatch.",
  });
  const textPasswordMismatch = formatMessage({
    id: 'message-error-passwordMismatch',
    defaultMessage: 'Password mismatch'
  });
  const generalAuthError = formatMessage({
    id: 'message-error-generalAuthError',
    defaultMessage: 'General login error, please try again or contact support'
  });
  const userDoesntExistError = formatMessage({
    id: 'message-error-userDoesntExistError',
    defaultMessage: 'User does not exist'
  });
  const userAlreadyExistsError = formatMessage({
    id: 'message-error-userAlreadyExistsError',
    defaultMessage: 'A user with this address already exists in the system'
  });
  const incorrectPasswordError = formatMessage({
    id: 'message-error-incorrectPasswordError',
    defaultMessage: 'Username or password is incorrect'
  });
  const checkLinkInEmail = formatMessage({
    id: 'message-check-link-in-email',
    defaultMessage: 'Check your email for a link'
  });
  const newPasswordMustBeDifferentFromOld = formatMessage({
    id: 'message-error-newPasswordMustBeDifferentFromOld',
    defaultMessage: 'The new password must be different from the old one'
  });
  const passwordIncorrect = formatMessage({
    id: 'message-error-settings-incorrectPasswordError',
    defaultMessage: 'Password is incorrect'
  });
  const multipleUsersFound = formatMessage({
    id: 'message-error-multipleUsersFound',
    defaultMessage: 'The phone number entered is configured in multiple accounts at the same time, please contact support for help'
  })
  const incorrectOTC = formatMessage({
    id: 'message-error-incorrectOTC',
    defaultMessage: 'Invalid code, please check that you have entered the correct code'
  })
  const notValidPhoneNumber = formatMessage({
    id: 'input-phone-error-not-valid-phone',
    defaultMessage: 'Is not valid phone number',
  });
  const fillPersonalDetails = formatMessage({
    id: 'message-fill-personal-details',
    defaultMessage: 'You must first fill in personal details and then return to this section.',
  });
  const userEmailAlreadyExistsError = formatMessage({
    id: 'message-error-userEmailAlreadyExistsError',
    defaultMessage: 'This email address already exists in the system'
  });
  const userPhoneAlreadyExistsError = formatMessage({
    id: 'message-error-userPhoneAlreadyExistsError',
    defaultMessage: 'This phone number already exists in the system'
  });
  const amountLessThan5Error = formatMessage({
    id: 'message-error-amountLessThan5Error',
    defaultMessage: 'Amount must be more than 5'
  });
  const createdAdditionalInvoice = formatMessage({
    id: 'orderInvoice-form-additional-invoice-was-created',
    defaultMessage: 'The invoice will be issued as a series, without changing or canceling the previous invoice'
  });
  const customerNameIsAgentNameError = formatMessage({
    id: 'orderInvoice-form-customer-name-is-agent-name-error',
    defaultMessage: 'Please enter the customer\'s name, not your own name'
  });
  const customerIdIsAgentIdError = formatMessage({
    id: 'orderInvoice-form-customer-id-is-agent-id-error',
    defaultMessage: 'Please enter the lesson\'s ID or PIN number, not yours'
  });
  const invalidIdNumberError = formatMessage({
    id: 'invalid-id-number',
    defaultMessage: 'Please enter a standard ID number or a standard Social Security number'
  });

  return {
    requiredField,
    notValidEmail,
    serverError,
    successCreatedInvoiceOrder,
    totalAmountErrorMessage,
    inviteSuccess,
    inviteError,
    userDetailsSuccess,
    textPasswordMismatch,
    generalAuthError,
    userDoesntExistError,
    userAlreadyExistsError,
    incorrectPasswordError,
    checkLinkInEmail,
    passwordChangeSuccess,
    currentPasswordMismatch,
    newPasswordMismatch,
    newPasswordMustBeDifferentFromOld,
    passwordIncorrect,
    multipleUsersFound,
    incorrectOTC,
    notValidPhoneNumber,
    fillPersonalDetails,
    userEmailAlreadyExistsError,
    userPhoneAlreadyExistsError,
    amountLessThan5Error,
    createdAdditionalInvoice,
    customerNameIsAgentNameError,
    customerIdIsAgentIdError,
    invalidIdNumberError
  };
};
